import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Icon } from '../../modules/icon';
import './ChatSidebar.css';

interface SessionRenameProps {
	sessionId: string;
	currentName: string;
	isEditing: boolean;
	editValue: string;
	isRenaming: boolean;
	onEditValueChange: (value: string) => void;
	onSave: (sessionId: string, newName: string) => void;
	onCancel: () => void;
	onEditClick: (e: React.MouseEvent) => void;
}

export function SessionRename({
	sessionId,
	currentName,
	isEditing,
	editValue,
	isRenaming,
	onEditValueChange,
	onSave,
	onCancel,
	onEditClick,
}: SessionRenameProps) {
	if (isEditing) {
		return (
			<div
				className='chat-session-edit-mode'
				onClick={(e) => e.stopPropagation()}
			>
				<input
					type='text'
					className='chat-session-edit-input'
					value={editValue}
					onChange={(e) => {
						const newValue = e.target.value;
						if (newValue.length <= 20) {
							onEditValueChange(newValue);
						}
					}}
					disabled={isRenaming}
					maxLength={20}
					autoFocus
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !isRenaming) {
							onSave(sessionId, editValue);
						}
						if (e.key === 'Escape') {
							onCancel();
						}
					}}
				/>

				{/* Character counter */}
				<div
					className={`chat-session-char-counter ${
						(editValue?.length ?? 0) >= 18 ? 'warning' : ''
					} ${(editValue?.length ?? 0) === 20 ? 'error' : ''}`}
				>
					{editValue?.length ?? 0}/20 characters
				</div>
				{/* Action buttons */}
				<div className='chat-session-edit-actions'>
					<Button
						variant='success'
						size='sm'
						onClick={(e) => {
							e.stopPropagation();
							onSave(sessionId, editValue);
						}}
						disabled={
							isRenaming || !editValue?.trim() || editValue?.length > 20
						}
					>
						{isRenaming ? (
							<>
								<Spinner animation='border' size='sm' className='me-1' />
								Saving...
							</>
						) : (
							'Save'
						)}
					</Button>
					<Button
						variant='outline-secondary'
						size='sm'
						onClick={(e) => {
							e.stopPropagation();
							onCancel();
						}}
						disabled={isRenaming}
					>
						Cancel
					</Button>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className='chat-session-id'>{currentName}</div>
			{/* Edit ikona */}
			<button
				className='chat-session-edit-btn'
				onClick={onEditClick}
				aria-label='Rename session'
				title='Rename session'
			>
				<Icon type='fa-solid fa-pencil' className='chat-session-edit-icon' />
			</button>
		</>
	);
}
